import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "m21.31 7.63-4.188-4.19a1.5 1.5 0 0 0-2.122 0L3.44 15A1.487 1.487 0 0 0 3 16.062v4.19a1.5 1.5 0 0 0 1.5 1.5h4.19a1.487 1.487 0 0 0 1.06-.44l11.56-11.56a1.5 1.5 0 0 0 0-2.122ZM8.69 20.25H4.5v-4.189l8.25-8.25 4.19 4.19-8.25 8.25Z"
    }, null, -1)
  ]))]))
}
export default { render: render }